import * as React from "react"
import { formatPercentage } from "@ui-seeker/utils/"

import { NotAllowedBlock, TagsBlock } from "@components"
import { adminScrapingDataReviewPercentageData } from "../../../@signals"


export default function eyecatchsColumn() {
	return {
		name: "eyecatchs",
		label: `Eyecatchs (${formatPercentage(adminScrapingDataReviewPercentageData.value["percentageEyecatchs"], { decimals: 2 })})`,
		options: {
			display: false,
			filter: false,
			setCellHeaderProps: () => ({
                sx: {
                    textAlign: "center",
                    minWidth: 80,
                    borderRight: "1px solid",
                    borderColor: "divider"
                }
            }),
			setCellProps: () => ({
                sx: {
                    textAlign: "center",
                    borderRight: "1px solid",
                    borderColor: "divider"
                }
            }),
			customBodyRowRender: value => {
                return value?.length ? <TagsBlock list={value} /> : <NotAllowedBlock />
            }
		}
	}
}